'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.init = init;

var _listeners = require('../utils/listeners');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var QuantityAdjuster = {
  init: function init(_ref) {
    var el = _ref.el,
        context = _ref.context;

    this.els = {
      el: el,
      controls: {
        minus: context.getElement('.' + context.className + '_Control-minus'),
        plus: context.getElement('.' + context.className + '_Control-plus')
      },
      input: context.getElement('.' + context.className + '_Input')
    };
    this.listeners = new _listeners.Listeners();

    this._value = parseInt(this.els.input.value, 10);

    this.handleMinusClick = this.handleMinusClick.bind(this);
    this.handlePlusClick = this.handlePlusClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleInput = this.handleInput.bind(this);

    this.setupListeners();
  },

  setupListeners: function setupListeners() {
    this.listeners.add(this.els.controls.minus, 'click', this.handleMinusClick);
    this.listeners.add(this.els.controls.plus, 'click', this.handlePlusClick);
    this.listeners.add(this.els.input, 'change', this.handleChange);
    this.listeners.add(this.els.input, 'input', this.handleInput);
  },

  handleMinusClick: function handleMinusClick() {
    if (this.value === 1) return;

    this.value -= 1;
  },

  handlePlusClick: function handlePlusClick() {
    this.value += 1;
  },

  handleInput: function handleInput() {
    var value = parseInt(this.els.input.value, 10);

    if (isNaN(value) === false) {
      this.value = value;
    }
  },

  handleChange: function handleChange() {
    var value = this.els.input.value;

    if (value === '') {
      this.value = 1;
    }
  },

  get value() {
    return this._value;
  },

  set value(val) {
    var _this = this;

    this.els.input.classList.remove('qty-Adjuster_Input-feedback');

    this._value = val < 1 ? 1 : val;

    this.els.input.value = this._value;

    this._value === 1 ? this.els.controls.minus.setAttribute('disabled', null) : this.els.controls.minus.removeAttribute('disabled');

    this.els.input.classList.add('qty-Adjuster_Input-feedback');

    setTimeout(function () {
      _this.els.input.classList.remove('qty-Adjuster_Input-feedback');
    }, 800);
  }
};

function init(_ref2) {
  var el = _ref2.el,
      context = _ref2.context;

  var quantityAdjuster = (0, _create2.default)(QuantityAdjuster);
  quantityAdjuster.init({ el: el, context: context });
}